
import { Link } from 'react-router-dom';

const CTAExperiencias = () => {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/a9a2b7cdb7164ea7300239616495c99e.jpg"
          alt="Machico Madeira"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-nature-green text-xs font-semibold uppercase tracking-widest mb-4">
            Seaview &amp; Levada Escape · Machico
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6 leading-tight">
            Pronto para Viver a <span className="font-serif italic">Madeira</span> de Perto?
          </h2>
          <p className="text-white/80 text-lg leading-relaxed mb-10">
            Fique nos nossos apartamentos em Machico e tenha todas estas experiências à porta de casa. 
            Reserve agora e receba um guia exclusivo de experiências locais.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Link
              to="/apartamentos"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-gray-900 rounded-full font-semibold text-base hover:bg-sand-beige transition-all whitespace-nowrap cursor-pointer group"
            >
              Ver Apartamentos
              <i className="ri-arrow-right-line ml-2 text-xl group-hover:translate-x-1 transition-transform"></i>
            </Link>
            <a
              href="https://wa.me/351912345678"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent text-white rounded-full font-semibold text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer border-2 border-white/50"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Falar Connosco
            </a>
          </div>

          <div className="flex flex-wrap gap-8">
            {[
              { icon: 'ri-map-pin-line', label: 'Machico, Madeira', sub: 'Junto à Levada do Caniçal' },
              { icon: 'ri-star-fill', label: '4.9 / 5 estrelas', sub: 'Mais de 200 avaliações' },
              { icon: 'ri-calendar-check-line', label: 'Reserva Direta', sub: 'Sem comissões' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-white/15 backdrop-blur-sm shrink-0">
                  <i className={`${item.icon} text-white text-xl`}></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{item.label}</p>
                  <p className="text-white/60 text-xs">{item.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAExperiencias;
